export default class OpenChatEvent {
    constructor(type, npcId) {
        this.type = type;
        this.npcId = npcId;
    }
}

OpenChatEvent.PERFORM = "OpenChatEvent.PERFORM";